import { Timeline as TimelineComponent } from './Timeline';
import { TimelineItem } from './TimelineItem';

export const Timeline = Object.assign(TimelineComponent, {
    Item: TimelineItem,
})
